import React from 'react'
import { Flex } from 'theme-ui'
import HardCodedBoxes from './HardCodedBoxes'
import componentOptionsSelector from '../../../helpers/componentOptionsSelector'
import generateLink from '../../../helpers/generateLink'
import ContentBox from './ContentBox'
import AnimationSelector from '../../Animation/AnimationSelector'

export default function ContentBoxes(props) {
  const {
    options,
    variantName,
    city,
    // configData,
    // businessData,
    poweredImages,
    isMultiLocationSite,
    locationIndex,
    allGeneral
  } = props

  const storyIds = options.storyId?.[locationIndex] // collects multiple ids
  const storyTag = options.storyTag?.[locationIndex]
  const usingStories = storyIds || storyTag ? true : false
  const storyData = usingStories ? (storyTag ? storyTag : storyIds) : undefined
  const storyObjects = storyData?.map((storyId, index) => {
    return componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag?.[index])
  })

  const StoryBoxes = () => {
    return storyObjects.map(({ titles, subtitles, textType, texts, images, ctaNames, ctaLinks }, index) => {
      const ctaLink = ctaLinks ? generateLink(ctaLinks, isMultiLocationSite, city) : ''
      return (
        <ContentBox
          key={index}
          variantName={variantName}
          ctaLink={ctaLink}
          image={images?.[0]}
          title={titles}
          subtitle={subtitles}
          text={texts}
          textType={textType}
          locationIndex={locationIndex}
          poweredImages={poweredImages}
        />
      )
    })
  }

  return (
    <AnimationSelector animation={options.animation}>
      <Flex variant={`${variantName}.contentBoxes`} className="contentBoxes">
        {usingStories ? StoryBoxes() : <HardCodedBoxes {...props} />}
      </Flex>
    </AnimationSelector>
  )
}
